exports.components = {
  "component---src-pages-external-terms-index-tsx": () => import("./../../../src/pages/external-terms/index.tsx" /* webpackChunkName: "component---src-pages-external-terms-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-lojas-index-tsx": () => import("./../../../src/pages/lojas/index.tsx" /* webpackChunkName: "component---src-pages-lojas-index-tsx" */),
  "component---src-pages-termos-index-tsx": () => import("./../../../src/pages/termos/index.tsx" /* webpackChunkName: "component---src-pages-termos-index-tsx" */)
}

